import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  category: {},
  errors: {},
  requesting: null,
  submitting: null,
  isSaved: false,
};

const Slice = createSlice({
  name: '@admin/Inventory|Categories|Form',
  initialState,
  reducers: {
    
    /**
     * RESET
     */
    initialState: (state) => {
      state.requesting = null;
      state.submitting = null;
      state.errors = {};
      state.category = {};
      state.isSaved = false;
    },

    /**
     * GET CATEGORY
     */
    getCategory: (state) => {
      state.requesting = true;
      state.category = {};
    },
    getCategorySuccess: (state, action) => {
      const { payload } = action;
      state.category = payload;
      state.requesting = false;
    },
    getCategoryFailed: (state, action) => {
      state.errors = action.payload;
      state.requesting = false;
    },

    /**
     * SAVE FORM
     */
    saveForm: (state) => {
      state.submitting = true;
      state.isSaved = false;
      state.errors = {};
    },
    saveFormSuccess: (state, action) => {
      const { payload } = action;
      state.category = payload;
      state.submitting = false;
      state.isSaved = true;
    },
    saveFormFailed: (state, action) => {
      state.errors = action.payload;
      state.submitting = false;
      state.isSaved = false;
    },
    
  },
});

export const Actions = Slice.actions;

const Reducers = {
  AdminInventoryCategoriesFormReducers: Slice.reducer,
}
export default Reducers;
